import {IEnvironment} from './environment.types';

export const environment: IEnvironment = {
    appName: 'aets',
    production: true,
    support_vendors_email: 'vendors@npa.gov.af',
    isWebSocketEnabled: false,
    baseUrl: {
        frontEnd: {
            main: 'https://tenders.ageops.af/'
        },
        backend: {
            main: 'https://tenders.ageops.af/'
        },
        ageops: {
            frontEnd: 'http://ageops.af/'
        },
        arcs: {
            frontEnd: 'http://arcs.local:4211/'
        },
        abcds: {
            frontEnd: 'http://abcds.local:4212/'
        },
        usm: {
            frontEnd: 'https://accounts.ageops.af/',
            backEnd: 'https://accounts.ageops.af/',
        },
        acpms: {
            frontEnd: 'https://acpms.ageops.af/'
        },
        aets: {
            frontEnd: 'https://tenders.ageops.af/'
        },
        anpcs: {
            frontEnd: 'https://anpcs.ageops.af/'
        },
        help: {
            frontEnd: 'https://help.ageops.af/'
        },
        ums: {
            backend: 'https://usm.ageops.af/'
        },
        fm: {
            backend: 'https://fm.ageops.af/',
        },
        commodities: {
            frontEnd: 'https://commodities.ageops.af/'
        },
        avrcs_2: {
            frontEnd: 'https://vendors.ageops.af/',
	    backend: 'https://vendors.ageops.af/'
        },
        webSocketServer: {
            main: 'https://tenders.ageops.af/'
        }
    },
    pki: {
        toolkitDownloadUrl: 'https://static-urls.s3.ap-northeast-2.amazonaws.com/pki-tool/NPA_PKI_Tool.zip'
    },
    fm: {
        largeLimitMb: 5,
        concurrencyCount: 5
    },

};
